<div
  class="px-6 pt-5 pb-4 flex flex-col gap-5 h-90 bg-surface dark:bg-surface-darkmode rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode"
>
  <div class="flex justify-start items-center gap-2 flex-wrap content-center">
    <div class="flex-1 flex flex-col">
      <ui-skeleton class="rounded-full w-full h-5 my-0.5" />
      <ui-skeleton class="rounded-full w-full h-4 my-0.5" />
    </div>
  </div>
  <ui-skeleton class="rounded-xl h-full w-full" />
  <ui-skeleton class="flex-none block rounded-md h-10 w-full" />
</div>
